import {Component, Input, OnInit} from '@angular/core';
import {Observable} from "rxjs";
import {ButtonConfig} from "@digidom/common";

@Component({
  selector: 'dd-buttons',
  templateUrl: './buttons.component.html',
  styleUrls: ['./buttons.component.scss']
})
export class ButtonsComponent implements OnInit {

  @Input()
  buttons$: Observable<ButtonConfig[] | undefined> | undefined;

  constructor() {
  }

  ngOnInit(): void {
  }

}
